/* global  */ // tUrl等のグローバル変数を宣言する
import scrollLock from './functions/_scrollLock.js' // スクロールロック
import getCookie from './functions/_cookie-getCookie.js' // Cookie取得
import setCookie from './functions/_cookie-setCookie.js' // Cookie発行
import autoScroll from './functions/_autoScroll.js' // 自動スクロール

import './_video'
import './_slide'
import './_api'
import './_search'
import './_playlist'
import './_tag-input'
import './_wish-delete'
import './_range-slider'
import './_image-slider'
import './_chat'
import './_placeholder'
import './_limitCountdown'
import './_news'
import './_videoPreview'
import './_textExpand'
import './_lazy'
import './_side'
import './_dragScroll'
import './_lang'

// const hogeData = getCookie('hogeData') // Cookie取得
// setCookie('hogeData', 'hogeText', 60 * 60) // Cookie発行
// setCookie('hogeData', 'hogeText', 60 * 60, false) // Cookie発行

if (!Element.prototype.matches) {
  Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector
}

if (!Element.prototype.closest) {
  Element.prototype.closest = function (s) {
    var el = this

    do {
      if (Element.prototype.matches.call(el, s)) return el
      el = el.parentElement || el.parentNode
    } while (el !== null && el.nodeType === 1)
    return null
  }
}

/*
 ##     ##          ######  ##    ## ##    ##  ######
 ##     ##         ##    ##  ##  ##  ###   ## ##    ##
 ##     ##         ##         ####   ####  ## ##
 ######### #######  ######     ##    ## ## ## ##
 ##     ##               ##    ##    ##  #### ##
 ##     ##         ##    ##    ##    ##   ### ##    ##
 ##     ##          ######     ##    ##    ##  ######
*/

window.hoverSync = function () {
  const hoverSyncClass = 'js-hoverSync'
  const hoverActiveClass = 'hover'
  const hoverItems = document.getElementsByClassName(hoverSyncClass)
  if (!hoverItems[0]) {
    return
  }

  for (let index = 0; index < hoverItems.length; index++) {
    const hoverItem = hoverItems[index]
    const hoverTargets = document.getElementsByClassName(hoverSyncClass + '--' + hoverItem.dataset.target)
    hoverItem.addEventListener(
      'mouseover',
      function () {
        for (let index = 0; index < hoverTargets.length; index++) {
          hoverTargets[index].classList.add(hoverActiveClass)
        }
      },
      false
    )
    hoverItem.addEventListener(
      'mouseout',
      function () {
        for (let index = 0; index < hoverTargets.length; index++) {
          hoverTargets[index].classList.remove(hoverActiveClass)
        }
      },
      false
    )
  }
}
window.hoverSync()

/*
 ##     ##  #######  ########     ###    ##
 #### #### ##     ## ##     ##  ##   ##  ##
 ## ### ## ##     ## ##     ## ##     ## ##
 ##     ## ##     ## ##     ## ######### ##
 ##     ##  #######  ########  ##     ## ########
*/

const modalOverlay = document.getElementById('modalOverlay') // モーダル用オーバーレイ
const modals = document.getElementsByClassName('js-modal') // モーダル本体
if (modals[0]) {
  window.addEventListener('click', (e) => {
    if (!e.target.closest('.js-modal-open')) {
      return
    }
    e.preventDefault()
    modalClose()
    const target = e.target.closest('.js-modal-open').dataset.modal
    const openModals = document.querySelectorAll('.js-modal--' + target)
    for (const openModal of openModals) {
      openModal.classList.add('active')
    }
    if (e.target.dataset.overlay) {
      modalOverlay.classList.add('active')
    }
    scrollLock('body', '.js-modal--' + target)
  })
  // モーダル撤去
  window.addEventListener('click', (e) => {
    if (!e.target.closest('.js-modal-close')) {
      return
    }
    e.preventDefault()
    modalClose()
    modalOverlay.classList.remove('active')
    scrollLock('body', '#modalOverlay')
  })
}

function modalClose() {
  // モーダルを消す
  for (let index = 0; index < modals.length; index++) {
    const modal = modals[index]
    modal.classList.remove('active')
  }
}
/*
          #######  ##     ##
         ##     ## ##     ##
         ##     ## ##     ##
 ####### ##     ## ##     ##
         ##     ##  ##   ##
         ##     ##   ## ##
          #######     ###
*/
if (document.getElementsByClassName('js-overlay')[0]) {
  window.addEventListener('click', (e) => {
    if (!e.target.closest('.js-overlay')) {
      return
    }
    modalOverlay.classList.add('active')
  })
}

/*
         #### ##     ##    ###     ######   ########
          ##  ###   ###   ## ##   ##    ##  ##
          ##  #### ####  ##   ##  ##        ##
 #######  ##  ## ### ## ##     ## ##   #### ######
          ##  ##     ## ######### ##    ##  ##
          ##  ##     ## ##     ## ##    ##  ##
         #### ##     ## ##     ##  ######   ########
*/
if (document.getElementsByClassName('js-imageModal')[0]) {
  window.addEventListener('click', (e) => {
    if (!e.target.closest('.js-imageModal')) {
      return
    }

    e.preventDefault()

    const href = e.target.getAttribute('href')

    document.getElementById('modalImage').src = href
    modalOverlay.classList.add('active')
  })
}

/*
  ######          ########  #######   ######    ######   ##       ########
 ##                  ##    ##     ## ##        ##        ##       ##
 ##       #######    ##    ##     ## ##   #### ##   #### ##       ######
 ##                  ##    ##     ## ##    ##  ##    ##  ##       ##
  ######             ##     #######   ######    ######   ######## ########

// クリックされたとき、属するグループのクラスを反転させる
<button type="button" class="js-clickToggle" data-toggle-group="hogeGroup"></button>
<div class="js-clickToggle--hogeGroup"></div>

*/
window.addEventListener('click', function (e) {
  if (!e.target.classList.contains('js-clickToggle')) {
    return
  }
  const group = e.target.dataset.toggleGroup
  toggleGroup(group, 'active')
})

function toggleGroup(group, className = 'active') {
  const hide = document.getElementsByClassName('js-clickToggle--' + group)
  for (let index = 0; index < hide.length; index++) {
    hide[index].classList.toggle(className)
  }
}

/*
 ########  #######     ###     ######  ########
    ##    ##     ##  ##   ##  ##          ##
    ##    ##     ## ##     ##  ######     ##
    ##    ##     ## #########       ##    ##
    ##     #######  ##     ##  ######     ##
*/
/*
トースト通知処理
<div id="js-toast" class="toast"></div>
window.popToast('テキスト')
*/

const toast = document.getElementById('js-toast') // トースト要素
let popToastTimer // トーストのタイマー
const popToastTimerVal = 5000 // トーストの保持時間
window.popToast = function (text, hold = false) {
  if (!toast) {
    // トースト要素の存在確認
    return
  }
  toast.innerHTML = text // テキストをセット
  toast.classList.add('active')

  if (!hold) {
    // 自動消滅までのタイマーをセット
    clearTimeout(popToastTimer)
    popToastTimer = setTimeout(function () {
      toast.classList.remove('active')
    }, popToastTimerVal)
  }
}
// PC時、マウスホバー中はトーストを保持する
if (toast) {
  toast.addEventListener(
    'mouseover',
    function () {
      if (window.matchMedia('(min-width:769px)').matches) {
        clearTimeout(popToastTimer)
      }
    },
    false
  )
  toast.addEventListener(
    'mouseout',
    function () {
      popToastTimer = setTimeout(function () {
        toast.classList.remove('active')
      }, popToastTimerVal)
    },
    false
  )
}

//   ####            ######   #####     ###     ####  ######
//  ##                 ##    ##   ##   ## ##   ##       ##
//  ##     ########    ##    ##   ##  ##   ##   ###     ##
//  ##                 ##    ##   ##  #######     ##    ##
//   ####              ##     #####   ##   ##  ####     ##
/*
<button type="button" class="js-clickToast" data-toast-on="お気に入りに登録しました" data-toast-off="お気に入りから削除しました">
</button>
*/
window.addEventListener('click', function (e) {
  if (!e.target.classList.contains('js-clickToast')) {
    return
  }
  // .activeの有無でONOFFを判断　.js-clickToggleの処理が先に行われる前提
  if (e.target.classList.contains('active')) {
    window.popToast(e.target.dataset.toastOn)
  } else {
    window.popToast(e.target.dataset.toastOff)
  }
})

/*
 ########          ######## ########     ###     ######  ########
 ##     ##            ##    ##     ##  ##   ##  ##       ##
 ##     ## #######    ##    ########  ##     ## ##       ######
 ##     ##            ##    ##   ##   ######### ##       ##
 ########             ##    ##     ## ##     ##  ######  ########

DOMを書き写す

*/

if (document.getElementsByClassName('js-clickDomTrace')[0]) {
  window.addEventListener('click', function (e) {
    if (!e.target.classList.contains('js-clickDomTrace')) {
      return
    }
    const from = document.querySelector(e.target.dataset.traceFrom)
    const to = document.querySelector(e.target.dataset.traceTo)

    to.innerHTML = from.innerHTML
  })
}

/*
 ##     ##         #### ##    ## ########  #######
 ###   ###          ##  ###   ## ##       ##     ##
 #### ####          ##  ####  ## ##       ##     ##
 ## ### ## #######  ##  ## ## ## ######   ##     ##
 ##     ##          ##  ##  #### ##       ##     ##
 ##     ##          ##  ##   ### ##       ##     ##
 ##     ##         #### ##    ## ##        #######

動画メニューの通知処理

*/
window.addEventListener('click', function (e) {
  if (!e.target.classList.contains('js-movieInfo')) {
    return
  }
  const infoType = e.target.dataset.info
  // .activeの有無でONOFFを判断　.js-clickToggleの処理が先に行われる前提
  const isActive = e.target.classList.contains('active')
  let text = ''

  if (infoType === 'channel') {
    text = 'チャンネル' + (isActive ? 'をお気に入り登録しました。' : 'のお気に入り登録を解除しました。')
  } else if (infoType === 'follow') {
    text = 'フォロー' + (isActive ? 'しました。' : 'を解除しました。')
  } else if (infoType === 'fan') {
    text = 'お気に入り登録' + (isActive ? 'しました。' : 'を解除しました。')
  } else if (infoType === 'like') {
    text = 'イイネ' + (isActive ? 'しました。' : 'を取り消しました。')
  } else if (infoType === 'fav') {
    text = 'お気に入り登録' + (isActive ? 'しました。' : 'を解除しました。')
  } else if (infoType === 'cart') {
    text = 'カート' + (isActive ? 'に追加しました。' : 'から削除しました。')
  } else if (infoType === 'need') {
    text = '欲しいものリスト' + (isActive ? 'に追加しました。' : 'から削除しました。')
  } else if (infoType === 'list') {
    text = '再生リスト' + (isActive ? 'に追加しました。' : 'から削除しました。')
  } else if (infoType === 'after') {
    text = '後で見る動画' + (isActive ? 'に追加しました。' : 'から削除しました。')
  } else if (infoType === 'hidden') {
    text = '動画' + (isActive ? 'を非表示にしました。' : 'の非表示を解除しました。')
  } else if (infoType === 'hide') {
    text = 'ユーザー' + (isActive ? 'を非表示にしました。' : 'の非表示を解除しました。')
  } else if (infoType === 'hide-model') {
    text = 'モデル' + (isActive ? 'を非表示にしました。' : 'の非表示を解除しました。')
  } else if (infoType === 'hide-channel') {
    text = 'チャンネル' + (isActive ? 'を非表示にしました。' : 'の非表示を解除しました。')
  } else {
    return
  }
  window.popToast(text)
})

/*
  ######  ##       #### ########  ########   #######     ###    ########  ########
 ##    ## ##        ##  ##     ## ##     ## ##     ##   ## ##   ##     ## ##     ##
 ##       ##        ##  ##     ## ##     ## ##     ##  ##   ##  ##     ## ##     ##
 ##       ##        ##  ########  ########  ##     ## ##     ## ########  ##     ##
 ##       ##        ##  ##        ##     ## ##     ## ######### ##   ##   ##     ##
 ##    ## ##        ##  ##        ##     ## ##     ## ##     ## ##    ##  ##     ##
  ######  ######## #### ##        ########   #######  ##     ## ##     ## ########
*/

window.addEventListener('click', function (e) {
  if (!e.target.classList.contains('js-clipboard')) {
    return
  }
  // ClipboardAPIが使えない場合はexecCommandで代用
  if (!navigator.clipboard) {
    const textarea = e.target.querySelector('textarea')
    textarea.select() // 内部のテキストエリアを選択
    document.execCommand('copy') // コピーコマンド
    textarea.blur() // SPは仮想キーボードが出てしまうのでフォーカスを外す
    window.popToast('クリップボードにコピーしました。')
    return
  }

  const text = e.target.dataset.clipText
  navigator.clipboard.writeText(text).then(
    function () {
      window.popToast('クリップボードにコピーしました。')
    },
    function () {
      window.popToast('クリップボードにコピーできませんでした。')
    }
  )
})

/*
 ##       #### ##    ## ########
 ##        ##  ##   ##  ##
 ##        ##  ##  ##   ##
 ##        ##  #####    ######
 ##        ##  ##  ##   ##
 ##        ##  ##   ##  ##
 ######## #### ##    ## ########

いいね数を増減する

*/
window.addEventListener('click', function (e) {
  if (!e.target.classList.contains('js-likeUpdate')) {
    return
  }
  const target = 'js-likeUpdate--' + e.target.dataset.id
  // .activeの有無でONOFFを判断　.js-clickToggleの処理が先に行われる前提
  const isActive = e.target.classList.contains('active')

  const likeList = document.getElementsByClassName(target)
  const likeVal = parseInt(likeList[0].innerText, 10) + (isActive ? 1 : -1)
  for (const likeItem of likeList) {
    likeItem.innerText = likeVal
  }
})

/*
  ######  ##     ## ########  ######  ##    ##          ######  ##    ## ##    ##  ######
 ##    ## ##     ## ##       ##    ## ##   ##          ##    ##  ##  ##  ###   ## ##    ##
 ##       ##     ## ##       ##       ##  ##           ##         ####   ####  ## ##
 ##       ######### ######   ##       #####    #######  ######     ##    ## ## ## ##
 ##       ##     ## ##       ##       ##  ##                 ##    ##    ##  #### ##
 ##    ## ##     ## ##       ##    ## ##   ##          ##    ##    ##    ##   ### ##    ##
  ######  ##     ## ########  ######  ##    ##          ######     ##    ##    ##  ######

同じチェックボックスを同期する

  */
window.addEventListener('change', function (e) {
  if (!e.target.classList.contains('js-checkSync')) {
    return
  }

  const name = e.target.dataset.checkName // チェックボックス名
  const checked = e.target.checked // チェック状態
  const checkList = document.querySelectorAll('[data-check-name="' + name + '"]')

  if (checked) {
    for (const checkbox of checkList) {
      checkbox.setAttribute('checked', 'checked')
    }
  } else {
    for (const checkbox of checkList) {
      checkbox.removeAttribute('checked')
    }
  }
})

/*
   ###          ##    ###    ##     ##
 ##   ##        ##  ##   ##    ## ##
##     ##       ## ##     ##    ###
######### ##    ## #########   ## ##
##     ##  ######  ##     ## ##     ##
*/
let ajax = false // Ajaxリクエスト
let ajaxResponse = '' // 最後のレスポンスを格納する
/*
        ##       #### ##    ## ##    ##
        ##        ##  ####  ## ##  ##
####### ##        ##  ## ## ## #####
        ##        ##  ##  #### ##  ##
        ######## #### ##    ## ##    ##

Aタグのリンク先と通信する
<a href="<?php echo termLink; ?>" class="js-linkAjax" data-from="#a" data-to="#a" data-push="on">

</a>
*/

window.addEventListener('click', (e) => {
  if (e.target.classList.contains('js-linkAjax')) {
    e.preventDefault()
    const item = e.target
    const url = item.attributes['href'].value // 取得先
    const type = item.dataset.type // add(追加)もしくはrep(差し替え)
    const from = item.dataset.from // 取得要素
    const to = item.dataset.to // 差し替え要素
    const pushSt = item.dataset.push // URLのプッシュ
    const scroll = item.dataset.scroll // スクロール先
    const flag = item.dataset.flag // 追加の処理フラグ
    applyAjax(url, from, to, pushSt, type, scroll, flag)
  }
})

/*
         #### ##    ##
          ##  ####  ##
 #######  ##  ## ## ##
          ##  ##  ####
         #### ##    ##

Intersection Observerで発火させる
連鎖的に読み込む場合はApplyのコールバックでもintObsAjax()を実行する
<div class="js-intAjax" data-from="#a" data-to="#a" data-type="add" data-push="off" data-url="">&emsp;</div>
*/

if (document.getElementsByClassName('js-intAjax')[0]) {
  intObsAjax()
}
function intObsAjax() {
  const intObsOption = {
    // root: document.querySelector('#obsArea'), // 監視領域 省略でビューポート
    rootMargin: '0px 0px', // 指定px,%分判定領域を増減する -50% 0pxで画面中央の走査線になる
    threshold: 0, // 発火判定の閾値 0.1=10%以上交差で発火 0で接触次第発火
  }
  const observer = new IntersectionObserver(intObsCallback, intObsOption)
  const intObsItems = document.getElementsByClassName('js-intAjax')
  for (let index = 0; index < intObsItems.length; index++) {
    const intObsItem = intObsItems[index]
    observer.observe(intObsItem) // 監視対象に加える
  }
  function intObsCallback(entries) {
    for (let index = 0; index < entries.length; index++) {
      const entry = entries[index]
      if (entry.isIntersecting) {
        const item = entry.target

        const url = item.dataset.url // 取得先
        const type = item.dataset.type // add(追加)もしくはrep(差し替え)
        const from = item.dataset.from // 取得要素
        const to = item.dataset.to // 差し替え要素
        const pushSt = item.dataset.push // URLのプッシュ
        const scroll = item.dataset.scroll // スクロール先
        const flag = item.dataset.flag // 追加の処理フラグ
        applyAjax(url, from, to, pushSt, type, scroll, flag)
        observer.unobserve(item) // 監視対象から外す
        item.parentNode.removeChild(item) // DOM削除
      }
    }
  }
}

/*
        #### ##    ## ########  ##     ## ########
         ##  ####  ## ##     ## ##     ##    ##
#######  ##  ## ## ## ########  ##     ##    ##
         ##  ##  #### ##        ##     ##    ##
        #### ##    ## ##         #######     ##

テキスト入力時に通信する
<input id="" class="js-textAjax" type="text" name="" placeholder="" data-url="<?php echo H_URL; ?>" data-from="#a" data-to="#a" data-push="on">
*/
let ajaxWord = ''
if (document.getElementsByClassName('js-textAjax')) {
  window.addEventListener('input', (e) => {
    if (e.target.classList.contains('js-textAjax')) {
      e.preventDefault()
      const item = e.target
      if (item.classList.contains('reset')) {
        item.classList.remove('reset')
      } else if (ajaxWord === item.value) {
        // キーワードが変わっていなければ処理しない
        return false
      }
      ajaxWord = item.value
      const url = item.dataset.url + encodeURI(ajaxWord) // 取得先
      const type = item.dataset.type // add(追加)もしくはrep(差し替え)
      const from = item.dataset.from // 取得要素
      const to = item.dataset.to // 差し替え要素
      const pushSt = item.dataset.push // URLのプッシュ
      const scroll = item.dataset.scroll // スクロール先
      applyAjax(url, from, to, pushSt, type, scroll)
    }
  })
}

/*
         ######  ######## ##       ########  ######  ########
        ##       ##       ##       ##       ##          ##
#######  ######  ######   ##       ######   ##          ##
              ## ##       ##       ##       ##          ##
         ######  ######## ######## ########  ######     ##

セレクトボックスの切替時、valueのURLに通信する
<select name="" class="js-selectAjax" data-from="#a" data-to="#a" data-push="on">
    <option value="https://example.com">最新順</option>
</select>
*/
if (document.getElementsByClassName('js-selectAjax')) {
  window.addEventListener('change', (e) => {
    if (e.target.classList.contains('js-selectAjax')) {
      e.preventDefault()
      const item = e.target
      const url = item.value // 取得先
      const type = item.dataset.type // add(追加)もしくはrep(差し替え)
      const from = item.dataset.from // 取得要素
      const to = item.dataset.to // 差し替え要素
      const pushSt = item.dataset.push // URLのプッシュ
      const scroll = item.dataset.scroll // スクロール先
      applyAjax(url, from, to, pushSt, type, scroll)
    }
  })
}

/*
        ##        #######     ###    ########
        ##       ##     ##  ##   ##  ##     ##
####### ##       ##     ## ##     ## ##     ##
        ##       ##     ## ######### ##     ##
        ########  #######  ##     ## ########

ページアクセス時にロードする
<div id="js-loadAjax" data-url="" data-from="" data-to=""></div>
*/
const loadAjax = document.getElementById('js-loadAjax')
if (loadAjax) {
  const item = loadAjax
  const url = item.dataset.url // 取得先
  const from = item.dataset.from // 取得要素
  const to = item.dataset.to // 差し替え要素
  applyAjax(url, from, to, false, 'rep', false)
}

/*
        ########     ###     ######  ##    ##
        ##     ##  ##   ##  ##       ##  ##
####### ########  ##     ## ##       #####
        ##     ## ######### ##       ##  ##
        ########  ##     ##  ######  ##    ##

ブラウザバックでのアクセス時にURL通りのものをロードする
<div id="js-backAjax" data-from="#a" data-to="#a"></div>
*/
const backAjax = document.getElementById('js-backAjax')
if (backAjax) {
  if (window.history && window.history.pushState) {
    window.onpopstate = function (e) {
      const item = backAjax
      const url = location.href // 取得先
      const from = item.dataset.from // 取得要素
      const to = item.dataset.to // 差し替え要素
      applyAjax(url, from, to, false, 'rep', false)
    }
  }
}

/*
           ###    ########  ########  ##       ##    ##
         ##   ##  ##     ## ##     ## ##         ####
####### ##     ## ########  ########  ##          ##
        ######### ##        ##        ##          ##
        ##     ## ##        ##        ########    ##
*/
/**
 * Ajax処理を実行する
 * @param url {string} 取得先のURL
 * @param from {string} 書き換え元のセレクタ　,区切りで複数指定
 * @param to {string} 取得先のセレクタ　,区切りで複数指定
 * @param pushSt {string|boolean} 擬似的にページ遷移する　falseじゃなければ有効
 * @param type {string} rep:要素を書き換える add:書き換え元の下に追加する
 * @param scroll {string} 指定の位置にスクロールさせる
 * @param flag {string} 独自の拡張用
 */
function applyAjax(url, from, to, pushSt, type = 'rep', scroll = false, flag = null) {
  from = from.split(',') // ,区切りで配列に変換
  to = to.split(',') // ,区切りで配列に変換

  if (pushSt === 'on') {
    history.pushState(null, null, url) // URL変更
  }

  // Ajaxと明示するパラメータを付ける
  url += (~url.indexOf('?') ? '&' : '?') + 'ajax=1'

  const loadingItem = document.createElement('div')
  loadingItem.className = 'md-loading active'

  // ローディング処理
  for (let index = 0; index < to.length; index++) {
    const itemTo = document.querySelector(to[index])
    const loadingItem = document.createElement('div')
    loadingItem.className = 'md-loading active'
    if (type === 'rep') {
      loadingItem.style.width = itemTo.offsetWidth + 'px'
      loadingItem.style.height = itemTo.offsetHeight + 'px'
      itemTo.innerHTML = ''
    }
    itemTo.appendChild(loadingItem)
  }

  if (ajax) {
    // 既に通信中なら切断
    ajax.abort()
  }

  ajax = new XMLHttpRequest() // Ajaxリクエスト
  ajax.open('GET', url, true) // GET/POST, URL, 非同期処理
  ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest') // Ajaxでのアクセスと明示するリクエストヘッダー
  // キャッシュせず最新のデータを取る場合のリクエストヘッダー3種
  // ajax.setRequestHeader('Pragma', 'no-cache')
  // ajax.setRequestHeader('Cache-Control', 'no-cache')
  // ajax.setRequestHeader('If-Modified-Since', 'Thu, 01 Jun 1970 00:00:00 GMT')
  ajax.responseType = 'document' // 取得タイプ document text json
  ajax.timeout = 10000 // タイムアウト判定時間
  ajax.send() // リクエスト実行
  ajax.onload = function () {
    // アクセス成功
    if (ajax.status < 200 || ajax.status >= 400) {
      console.log('Error: Code ' + ajax.status) // エラー
      return
    }

    if (ajax.response === ajaxResponse) {
      // 前と結果が同じなら何もしない
      return
    }
    ajaxResponse = ajax.response // 取得結果を更新

    let ajaxData = ajaxResponse // 実際に使用するデータ

    // // IEは取得タイプJSONをtextで受け取るのでJSONにパースする
    // if (navigator.userAgent.indexOf('Trident') !== -1 && JSON) {
    //   ajaxData = JSON.parse(ajaxData)
    // }

    for (let index = 0; index < to.length; index++) {
      const itemFrom = this.response.querySelector(from[index])
      const itemTo = document.querySelector(to[index])

      if (type === 'rep') {
        itemTo.innerHTML = itemFrom.innerHTML
      } else {
        // addなら既存の要素を消さずに追加
        const delLoading = itemTo.querySelector('.md-loading')
        delLoading.parentNode.removeChild(delLoading)
        itemTo.innerHTML += itemFrom.innerHTML
      }
      if (scroll) {
        autoScroll(scroll, '#header', true)
      }
    }

    // プレイリストソート用　掴んでいるアイテムを消す
    const drugItem = document.getElementsByClassName('js-drugSort-grip')
    if (drugItem[0]) {
      for (const iterator of drugItem) {
        iterator.style.display = 'none'
      }
    }
  }
  ajax.ontimeout = function (e) {
    // タイムアウト
  }
  ajax.onerror = function () {
    // Ajax処理失敗
  }
  ajax.onloadend = function () {
    // 受信成否に関わらず実行
    intObsAjax()

    window.slider()
    window.videoPreview()
    window.textExpand() // クリックでテキストを開閉
    ajax = false
  }
}

/*
//  #####   #####   #####    ###    ###
//  ##     ##   ##  ##  ##   ## #  # ##
//  #####  ##   ##  #####    ##  ##  ##
//  ##     ##   ##  ##  ##   ##      ##
//  ##      #####   ##   ##  ##      ##

フォーム送信して結果を反映する

<form action="hoge.php" method="POST" name="form-name">
  <button type="button" class="js-ajaxSubmit" data-form="form-name" data-input="type,item" data-require="" data-message="送信が完了しました。">
      更新
  </button>
</form>

*/
ajaxForm()

function ajaxForm() {
  let ajax = false // Ajaxリクエスト

  window.addEventListener('click', (e) => {
    if (e.target.classList.contains('js-ajaxSubmit') && e.target.tagName === 'BUTTON') {
      e.preventDefault()
      ajaxSubmit(e.target)
    }
  })

  window.addEventListener('change', (e) => {
    if (e.target.classList.contains('js-ajaxSubmit')) {
      e.preventDefault()
      ajaxSubmit(e.target)
    }
  })

  function ajaxSubmit(item) {
    let param = '' // 送信パラメータ
    const name = item.dataset.form
    const form = document.forms[name] // 指定nameのformに存在するinputにアクセス
    const url = form.action // 取得先
    const method = form.method // GET/POST
    const message = item.dataset.message

    const type = item.dataset.type // add(追加)もしくはrep(差し替え)
    const from = item.dataset.from // 取得要素
    const to = item.dataset.to // 差し替え要素
    const pushSt = item.dataset.push // URLのプッシュ
    const scroll = item.dataset.scroll // スクロール先
    const reload = item.dataset.reload // リロード

    // 指定されているinputを取得して送信データ化する
    const inputList = item.dataset.input.split(',') // ,区切りで配列に変換

    for (let index = 0; index < inputList.length; index++) {
      if (index !== 0) {
        param += '&'
      }
      const input = inputList[index]
      const valueForm = document.querySelector('form[name="' + name + '"]')
      const valueList = valueForm.querySelectorAll('[name="' + input + '"]')

      let value = ''

      for (const valueItem of valueList) {
        if ((valueItem.type === 'checkbox' || valueItem.type === 'radio') && !valueItem.checked) {
          // チェックされていないチェックボックス類は回収しない
          continue
        }
        if (value !== '') {
          value += ',' // 配列系のデータはカンマ区切りにする
        }
        value += valueItem.value
      }

      param += input + '=' + encodeURIComponent(value)
    }
    applyAjax(url, method, param, from, to, pushSt, type, scroll, message)
    if (reload) {
      // 指定のエリアをリロードする
      setTimeout(() => {
        applyAjax(location.href, 'get', '', reload, reload, false, 'rep', false, null, 'reload')
      }, 1500)
    }
  }

  /**
   * Ajax処理を実行する
   * @param url {string} 取得先のURL
   * @param flag {string} 独自の拡張用
   */

  function applyAjax(
    url,
    method = 'POST',
    param,
    from,
    to,
    pushSt,
    type = 'rep',
    scroll = false,
    message = null,
    flag = null
  ) {
    from = from ? from.split(',') : null // ,区切りで配列に変換
    to = to ? to.split(',') : null // ,区切りで配列に変換
    const errorText = 'エラーが発生しました。時間をおいて再度お試しください。'

    if (to) {
      const loadingItem = document.createElement('div')
      loadingItem.className = 'md-loading active'

      // ローディング処理
      for (let index = 0; index < to.length; index++) {
        const itemTo = document.querySelector(to[index])
        const loadingItem = document.createElement('div')
        loadingItem.className = 'md-loading active'
        if (type === 'rep') {
          loadingItem.style.width = itemTo.offsetWidth + 'px'
          loadingItem.style.height = itemTo.offsetHeight + 'px'
          itemTo.innerHTML = ''
        }
        itemTo.appendChild(loadingItem)
      }
    }

    // if (ajax) {
    //   // 既に通信中なら切断
    //   ajax.abort()
    // }
    ajax = new XMLHttpRequest() // Ajaxリクエスト

    let sendUrl = url
    if (method !== 'POST' && param) {
      if (~sendUrl.indexOf('?')) {
        sendUrl += '&' + param
      } else {
        sendUrl += '?' + param
      }
    }

    if (method === 'POST') {
      ajax.open(method, url, true) // GET/POST, URL, 非同期処理
    } else {
      ajax.open(method, sendUrl, true) // GET/POST, URL, 非同期処理
      if (pushSt === 'on') {
        history.pushState(null, null, url + '?' + param) // URL変更
      }
    }
    ajax.setRequestHeader('X-Requested-With', 'XMLHttpRequest') // Ajaxでのアクセスと明示するリクエストヘッダー
    // キャッシュせず最新のデータを取る場合のリクエストヘッダー3種
    // ajax.setRequestHeader('Pragma', 'no-cache')
    // ajax.setRequestHeader('Cache-Control', 'no-cache')
    // ajax.setRequestHeader('If-Modified-Since', 'Thu, 01 Jun 1970 00:00:00 GMT')
    if (method === 'POST') {
      ajax.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded') // POST時に必要なリクエストヘッダー
    }
    ajax.responseType = 'document' // 取得タイプ document text json
    ajax.timeout = 10000 // タイムアウト判定時間
    if (method === 'POST') {
      ajax.send(param) // POSTリクエスト実行
    } else {
      ajax.send() // GETリクエスト実行
    }
    ajax.onload = function () {
      // アクセス成功
      if (ajax.status < 200 || ajax.status >= 400) {
        console.log('Error: Code ' + ajax.status) // エラー

        window.popToast(errorText)

        return
      }
      if (from && to) {
        const ajaxData = ajax.response
        for (let index = 0; index < to.length; index++) {
          const itemFrom = this.response.querySelector(from[index])
          const itemTo = document.querySelector(to[index])

          if (type === 'rep') {
            itemTo.innerHTML = itemFrom.innerHTML
          } else {
            // addなら既存の要素を消さずに追加
            const delLoading = itemTo.querySelector('.md-loading')
            delLoading.parentNode.removeChild(delLoading)
            itemTo.innerHTML += itemFrom.innerHTML
          }
        }
        if (scroll) {
          autoScroll(scroll, '#header', true)
        }
      }

      if (message) {
        window.popToast(message)
      }
    }
    ajax.ontimeout = function (e) {
      // タイムアウト
      window.popToast(errorText)
    }
    ajax.onerror = function () {
      // Ajax処理失敗
      window.popToast(errorText)
    }
    ajax.onloadend = function () {
      // 受信成否に関わらず実行
      // intObsAjax()

      ajax = false
    }
  }
}

/*
 ########  ######## ########   #######  ########  ########
 ##     ## ##       ##     ## ##     ## ##     ##    ##
 ##     ## ##       ##     ## ##     ## ##     ##    ##
 ########  ######   ########  ##     ## ########     ##
 ##   ##   ##       ##        ##     ## ##   ##      ##
 ##    ##  ##       ##        ##     ## ##    ##     ##
 ##     ## ######## ##         #######  ##     ##    ##

 報告フォーム　ラジオボタンがチェックされたら送信可能にする
*/
const reqRadio = document.getElementsByClassName('js-reqRadio')
window.addEventListener('change', function (e) {
  // 指定のクラスを持つ
  if (!e.target.classList.contains('js-reqRadio')) {
    return
  }
  const target = e.target.dataset.target
  document.querySelector('.js-reqRadio--' + target).classList.remove('is-false')
})

/*
  ######     ###    ########  ########
 ##    ##   ## ##   ##     ##    ##
 ##        ##   ##  ##     ##    ##
 ##       ##     ## ########     ##
 ##       ######### ##   ##      ##
 ##    ## ##     ## ##    ##     ##
  ######  ##     ## ##     ##    ##
*/
const cartBtn = document.getElementsByClassName('js-cartBtn')

window.addEventListener('click', function (e) {
  // 指定のクラスを持つ
  if (!e.target.classList.contains('js-cartBtn')) {
    return
  }
  const target = e.target.dataset.target
  document.querySelector('.js-reqRadio--' + target).classList.remove('is-false')
})

/*
  ######   #######  ##        #######  ########
 ##       ##     ## ##       ##     ## ##     ##
 ##       ##     ## ##       ##     ## ########
 ##       ##     ## ##       ##     ## ##   ##
  ######   #######  ########  #######  ##     ##

チェックボックスを兼ねたカラーピッカー
カラーピッカーを選択した時にチェックを入れ、目印になる要素の背景色を変更する

<label class="" for="bgFree">
    <input type="radio" name="bg-color" value="#000" class="js-checkColor-check--bg settingColor__check">
    <div class="js-checkColor-css--bg flex vcenter hcenter" style="background:#000"></div>
    カラーパレットで選択
    <input type="color" id="bgFree" name="" class="js-checkColor" data-color="bg" value="#000">
</label>

*/
const colorCheck = document.getElementsByClassName('js-checkColor')
if (colorCheck[0]) {
  window.addEventListener('click', function (e) {
    if (e.target.classList.contains('js-checkColor')) {
      applyColorCheck(e.target)
    }
  })
  window.addEventListener('input', function (e) {
    if (e.target.classList.contains('js-checkColor')) {
      applyColorCheck(e.target)
    }
  })
  window.addEventListener('change', function (e) {
    if (e.target.classList.contains('js-checkColor')) {
      applyColorCheck(e.target)
    }
  })
}

function applyColorCheck(item) {
  const name = item.dataset.color // 制御対象識別名
  const color = item.value // 選択カラー

  // チェック要素を制御する
  const checkTarget = document.getElementsByClassName('js-checkColor-check--' + name)
  for (const target of checkTarget) {
    target.value = color
    target.checked = true
  }

  // 背景色を変更する
  const cssTarget = document.getElementsByClassName('js-checkColor-css--' + name)
  for (const target of cssTarget) {
    target.style.background = color
  }
}

/*
 ########     ###     ######   ######  ##      ##  #######  ########  ########
 ##     ##  ##   ##  ##       ##       ##  ##  ## ##     ## ##     ## ##     ##
 ########  ##     ##  ######   ######  ##  ##  ## ##     ## ########  ##     ##
 ##        #########       ##       ## ##  ##  ## ##     ## ##   ##   ##     ##
 ##        ##     ##  ######   ######   ###  ###   #######  ##     ## ########

パスワードの表示非表示を切り替える

<input name="password" class="" type="password" value="" placeholder="パスワード">
<button type="button" class="js-passwordView flex vcenter hcenter activeToggle" data-name="password">
    <i class="is-false icon-password-view activeToggle__off"></i>
    <i class="is-false icon-password-hide activeToggle__on"></i>
</button>

*/
const passwordView = document.getElementsByClassName('js-passwordView')
if (passwordView[0]) {
  window.addEventListener('click', function (e) {
    if (!e.target.classList.contains('js-passwordView')) {
      return
    }
    const name = e.target.dataset.name
    e.target.classList.toggle('active')

    const target = document.querySelector('input[name="' + name + '"]')
    // console.log(target)
    if (e.target.classList.contains('active')) {
      target.type = 'text'
    } else {
      target.type = 'password'
    }
  })
}

/*
    ###     ######   ########  ######## ########
   ## ##   ##    ##  ##     ## ##       ##
  ##   ##  ##        ##     ## ##       ##
 ##     ## ##   #### ########  ######   ######
 ######### ##    ##  ##   ##   ##       ##
 ##     ## ##    ##  ##    ##  ##       ##
 ##     ##  ######   ##     ## ######## ########
*/
const checkToggle = document.getElementsByClassName('js-checkToggle')
if (checkToggle[0]) {
  window.addEventListener('change', function (e) {
    if (!e.target.classList.contains('js-checkToggle')) {
      return
    }
    const name = e.target.dataset.check
    const targetList = document.getElementsByClassName('js-checkToggle--' + name)

    if (e.target.checked) {
      for (const iterator of targetList) {
        iterator.classList.add('active')
      }
    } else {
      for (const iterator of targetList) {
        iterator.classList.remove('active')
      }
    }
  })
}

/*
    ###    ##       ##                ######  ##     ## ########  ######  ##    ##
  ##   ##  ##       ##               ##       ##     ## ##       ##       ##  ##
 ##     ## ##       ##       ####### ##       ######### ######   ##       #####
 ######### ##       ##               ##       ##     ## ##       ##       ##  ##
 ##     ## ######## ########          ######  ##     ## ########  ######  ##    ##

同一グループすべてを切り替えるチェック

<input type="checkbox" name="all" class="js-allCheck" data-all-check="hoge">
<input type="checkbox" name="" class="js-allCheck--hoge js-allCheck-child " data-all-check="hoge">
*/
if (document.getElementsByClassName('js-allCheck')[0]) {
  allCheck()
}
function allCheck() {
  // 親の切り替えを子に反映する
  window.addEventListener('change', function (e) {
    if (!e.target.classList.contains('js-allCheck')) {
      return
    }
    childUpdate(e)
    parentUpdate(e) // 親が複数あることを想定して親も更新する
  })
  // 子の状態を親に反映する
  window.addEventListener('change', function (e) {
    if (!e.target.classList.contains('js-allCheck-child')) {
      return
    }
    parentUpdate(e)
  })
  function childUpdate(e) {
    const checked = e.target.checked // 親のチェック状態取得
    const group = e.target.dataset.allCheck // グループ取得
    const checkList = document.getElementsByClassName('js-allCheck--' + group) // 子チェックボックス
    // 親のチェック状態を子に伝播させる
    for (let index = 0; index < checkList.length; index++) {
      checkList[index].checked = checked
    }
  }
  function parentUpdate(e) {
    const group = e.target.dataset.allCheck // グループ取得
    const checkList = document.getElementsByClassName('js-allCheck--' + group) // 子チェックボックス
    const checkListChecked = document.querySelectorAll('.js-allCheck--' + group + ':checked') // チェック済みの子
    const checkCurrentList = document.querySelectorAll('.js-allCheck[data-all-check="' + group + '"]') // 親チェック

    // 子チェック数とチェックされている子チェックの数の比較結果が解になる
    const result = checkList.length === checkListChecked.length

    // すべての親チェックに結果を反映する
    for (const checkCurrent of checkCurrentList) {
      checkCurrent.checked = result
    }
  }
}

/*
  ######   #######  #### ##    ##
 ##    ## ##     ##  ##  ###   ##
 ##       ##     ##  ##  ####  ##
 ##       ##     ##  ##  ## ## ##
 ##       ##     ##  ##  ##  ####
 ##    ## ##     ##  ##  ##   ###
  ######   #######  #### ##    ##
*/
const coinInput = document.getElementsByClassName('js-coinInput')
const coinInputResult = document.getElementsByClassName('js-coinInput-result')
const coinInputFree = document.querySelector('.js-coinInput-free')
if (coinInput[0]) {
  window.addEventListener('change', function (e) {
    // 指定のクラスを持つ
    if (!e.target.classList.contains('js-coinInput')) {
      return
    }
    if (e.target.value === 'free') {
      coinPrice(coinInputFree)
    } else {
      coinPrice(e.target)
    }
  })
  window.addEventListener('change', function (e) {
    // 指定のクラスを持つ
    if (!e.target.classList.contains('js-coinInput-free')) {
      return
    }
    for (const radio of coinInput) {
      if (!radio.checked) {
        continue
      }
      if (radio.value === 'free') {
        coinPrice(coinInputFree)
        break
      }
    }
  })
}

function coinPrice(item) {
  const coin = item.value ? parseInt(item.value, 10) : 0

  for (const price of coinInputResult) {
    const basePrice = parseInt(price.dataset.base, 10)
    const resultPrice = parseInt(basePrice - coin, 10)

    price.innerText = resultPrice >= 0 ? comma(resultPrice) : 0
  }
}

//   ####   #####   ###    ###  ###    ###    ###
//  ##     ##   ##  ## #  # ##  ## #  # ##   ## ##
//  ##     ##   ##  ##  ##  ##  ##  ##  ##  ##   ##
//  ##     ##   ##  ##      ##  ##      ##  #######
//   ####   #####   ##      ##  ##      ##  ##   ##
// カンマ区切り
function comma(value) {
  return value.toLocaleString()
}

//   ####  #####     #####   #####
//  ##     ##  ##   ##   ##  ##  ##
//  ##     #####    ##   ##  #####
//  ##     ##  ##   ##   ##  ##
//   ####  ##   ##   #####   ##

const cropEdit = document.getElementById('userImage-crop')
const cropPreview = document.getElementById('userImage-view')
const cropData = document.getElementById('userImage-data')
const cropExt = document.getElementById('userImage-ext')
const cropMime = document.getElementById('userImage-mime')
let cropper

if (document.getElementById('userImage-up')) {
  window.addEventListener('change', function (e) {
    if (e.target.id !== 'userImage-up') {
      return
    }

    const file = e.target.files[0]
    const fileName = file.name

    const fileSizeLimit = 300 // サイズ上限（KB）
    const sizeUnit = file.size > 1024 * 1024 ? 'MB' : 'KB' // 単位をMBかKBに分岐
    const fileSizeUnit = sizeUnit === 'MB' ? file.size / (1024 * 1024) : file.size / 1024 // 単位に合わせて補正したファイルサイズ
    const fileSizeView = fileSizeUnit.toFixed(2) + sizeUnit // ファイルサイズ出力テキスト

    let getExt = checkExt(fileName, '.jpg,.jpeg,.png,.gif') // 拡張取得
    if (!getExt) {
      // 無効な拡張子は弾く
      window.popToast('対応する画像形式ではありません。')
      return
    }

    // サイズバリデーション
    if (file.size > fileSizeLimit * 1024) {
      window.popToast('ファイルサイズは' + fileSizeLimit + 'KB以下にしてください (' + fileSizeView + ')。')
      return
    }

    // 拡張子からMIMEタイプを求める
    // GIFにPNGに変換されるので補正する
    getExt = getExt === 'gif' ? 'png' : getExt
    let getMime
    if (getExt === 'png') {
      getMime = 'image/png'
    } else {
      getMime = 'image/jpeg'
    }

    const reader = new FileReader()
    reader.onload = () => {
      document.getElementById('userImage-hide').classList.remove('is-none') // 非表示解除
      cropEdit.src = reader.result
      if (cropper) {
        cropper.destroy()
        cropper = null
      }
      crop(getExt, getMime)
    }
    reader.readAsDataURL(file)
  })
}

function crop(ext, mime) {
  /* global Cropper */
  cropper = new Cropper(cropEdit, {
    aspectRatio: 3 / 3,
    ready(event) {
      cropData.value = cropper.getCroppedCanvas().toDataURL(mime)
      cropMime.value = mime
      cropExt.value = ext
      cropPreview.src = cropper.getCroppedCanvas().toDataURL(mime)
    },
    crop(event) {},
    cropend(event) {
      cropData.value = cropper.getCroppedCanvas().toDataURL(mime)
      cropMime.value = mime
      cropExt.value = ext
      cropPreview.src = cropper.getCroppedCanvas().toDataURL(mime)
    },
  })
}

// 文字列から拡張子を返す
function getExt(fileName) {
  var pos = fileName.lastIndexOf('.')
  if (pos === -1) return ''
  return fileName.slice(pos + 1)
}
// 拡張子を検証する
function checkExt(fileName, exts) {
  //比較のため小文字にする
  var ext = getExt(fileName).toLowerCase()
  //許可する拡張子の一覧(allow_exts)から対象の拡張子があるか確認する
  if (exts.indexOf(ext) === -1) {
    return false
  }
  return ext
}

/*
######## #### ##     ##
##        ##    ## ##
######    ##     ###
##        ##    ## ##
##       #### ##     ##
*/
// stickyの代替処理
if (document.getElementById('js-fixArea')) {
  fixArea()
}
function fixArea() {
  let isWait = false // 待機フラグ
  let scrollY = window.pageYOffset // 縦方向のスクロール量
  const frame = document.getElementById('js-fixArea') // フレーム
  const item = document.getElementById('js-fixArea-item') // スクロールさせるアイテム
  const adjust = document.getElementById('header').offsetHeight * 1.5 // ヘッダー要素の調整
  let state = 'stay'
  document.addEventListener(
    'scroll',
    function () {
      fixAreaApply()
    },
    { passive: true }
  )
  fixAreaApply()
  function fixAreaApply() {
    if (isWait) {
      return
    }
    isWait = true
    // レンダリング準備が整ったら開始
    requestAnimationFrame(function () {
      scrollY = window.pageYOffset // スクロール量
      const frameHeight = frame.offsetHeight
      const frameTop = frame.getBoundingClientRect().top + scrollY
      const frameBottom = frameTop + frameHeight
      const itemHeight = item.offsetHeight
      const itemTop = item.getBoundingClientRect().top + scrollY
      const itemBottom = itemTop + itemHeight
      // フレームがアイテムより高くなければ終了
      if (frameHeight <= itemHeight) {
        isWait = false // フラグをOFFに戻す
        return
      }

      if (state === 'stay') {
        // スクロールがアイテムのTOPを追い越したら追従
        if (scrollY + adjust >= itemTop) {
          item.classList.add('move')
          state = 'move'
        }
      } else if (state === 'move') {
        if (itemTop <= frameTop) {
          item.classList.remove('move')
          state = 'stay'
        } else if (itemBottom >= frameBottom) {
          item.classList.remove('move')
          item.classList.add('end')
          state = 'end'
        }
      } else {
        if (item.getBoundingClientRect().top > adjust) {
          item.classList.remove('end')
          item.classList.add('move')
          state = 'move'
        }
      }
      isWait = false
    })
  }
}

document.addEventListener(
  'dblclick',
  function (e) {
    e.preventDefault()
  },
  { passive: false }
)

//  ######            ##      ##    ###    ##  ######
//    ##              ##      ##   ## ##   ##    ##
//    ##    ########  ##  ##  ##  ##   ##  ##    ##
//    ##              ##  ##  ##  #######  ##    ##
//    ##               ###  ###   ##   ##  ##    ##

window.addEventListener('change', function (e) {
  textWait(e)
})
window.addEventListener('input', function (e) {
  textWait(e)
})
function textWait(e) {
  // 指定のクラスを持つ
  if (!e.target.classList.contains('js-textWait')) {
    return
  }
  const item = e.target
  const target = document.querySelector('.js-textWait--' + item.dataset.wait)
  if (item.value !== '') {
    target.classList.remove('is-disable')
  } else {
    target.classList.add('is-disable')
  }
}

//      ##  ##   ##  ###    ###  #####
//      ##  ##   ##  ## #  # ##  ##  ##
//      ##  ##   ##  ##  ##  ##  #####
//  ##  ##  ##   ##  ##      ##  ##
//   ####    #####   ##      ##  ##

const rootDomain = 'gramov.com' // ルートドメイン

window.addEventListener('click', function (e) {
  // 指定のクラスを持つ
  if (e.target.classList.contains('js-jumpCookie')) {
    const href = e.target.href
    // Cookieを設定
    if (!href) {
      setCookie('jump', '', 0, true) // Cookie発行
      setCookie('jump', '', 0, true, '/', 'lax', ';domain=.' + location.hostname) // Cookie発行
      if (location.hostname !== rootDomain) {
        setCookie('jump', '', 0, true, '/', 'lax', ';domain=.' + rootDomain) // Cookie発行
      }
    } else {
      setCookie('jump', href, 60 * 60 * 24 * 360, true) // Cookie発行
      setCookie('jump', href, 60 * 60 * 24 * 360, true, '/', 'lax', ';domain=.' + location.hostname) // Cookie発行
      if (location.hostname !== rootDomain) {
        setCookie('jump', href, 60 * 60 * 24 * 360, true, '/', 'lax', ';domain=.' + rootDomain) // Cookie発行
      }
    }
  }
})

//  #####      ###    ######  #####
//  ##  ##    ## ##     ##    ##
//  #####    ##   ##    ##    #####
//  ##  ##   #######    ##    ##
//  ##   ##  ##   ##    ##    #####
// レーティングの確認を省略する

const rateBtn = document.getElementById('rateAgree')
const rateLink = rateBtn.href

// 承諾したらCookieを記録
window.addEventListener('click', function (e) {
  // 指定のIDを持つ
  if (e.target.id !== 'rateAgree') {
    return
  }
  // Cookieを設定
  setCookie('darkMode', 0, 60 * 60 * 24 * 365, true) // Cookie発行
  setCookie('darkMode', 0, 60 * 60 * 24 * 365, true, '/', 'lax', ';domain=.' + location.hostname) // Cookie発行
  if (location.hostname !== rootDomain) {
    setCookie('darkMode', 0, 60 * 60 * 24 * 365, true, '/', 'lax', ';domain=.' + rootDomain) // Cookie発行
  }
  setCookie('rateAgree', 0, 60 * 60 * 24 * 7, true) // Cookie発行
  setCookie('rateAgree', 0, 60 * 60 * 24 * 7, true, '/', 'lax', ';domain=.' + location.hostname) // Cookie発行
  if (location.hostname !== rootDomain) {
    setCookie('rateAgree', 0, 60 * 60 * 24 * 7, true, '/', 'lax', ';domain=.' + rootDomain) // Cookie発行
  }

  // ポップアップを閉じる
  modalClose()
})

// Cookieがあったらモーダルをカット
const rateAgree = getCookie('darkMode') // Cookie取得
if (rateAgree === '0') {
  // モーダルを消す
  const modalList = document.querySelectorAll('.js-modal--rating.active')
  for (const modal of modalList) {
    modal.classList.remove('active')
  }
}

// 表に戻る
window.addEventListener('click', function (e) {
  // 指定のクラスを持つ
  if (!e.target.classList.contains('js-lightMode')) {
    return
  }
  setCookie('darkMode', '', 0, true) // Cookie発行
  setCookie('darkMode', '', 0, true, '/', 'lax', ';domain=.' + location.hostname) // Cookie発行
  if (location.hostname !== rootDomain) {
    setCookie('darkMode', '', 0, true, '/', 'lax', ';domain=.' + rootDomain) // Cookie発行
  }

  window.location.reload()
})

//  ####              ##   ##  ##  ####    #####
//  ##  ##            ##   ##  ##  ##  ##  ##
//  ##  ##  ########  #######  ##  ##  ##  #####
//  ##  ##            ##   ##  ##  ##  ##  ##
//  ####              ##   ##  ##  ####    #####
// 下スクロールで非表示、上スクロールで表示する処理
downHide()
function downHide() {
  const hideList = document.getElementsByClassName('js-downHide')
  if (!hideList[0]) {
    return
  }
  let scrollPoint = 0 // 現在のスクロール位置をセットする変数
  let lastPoint = 0 // 1つ前のスクロール位置をセットする変数
  let lastAction = null // 最後のアクション
  let isExecute = false // 実行中判定

  window.addEventListener('scroll', function () {
    if (isExecute) {
      // 実行中ならスキップ
      return
    }
    isExecute = true // 実行中

    scrollPoint = window.scrollY

    if (lastAction !== 'down' && scrollPoint > lastPoint) {
      // 下スクロール
      lastAction = 'down'
      for (const target of hideList) {
        target.classList.remove('active')
      }
    } else if (lastAction !== 'up' && scrollPoint < lastPoint) {
      // 上スクロール
      lastAction = 'up'
      for (const target of hideList) {
        target.classList.add('active')
      }
    }
    lastPoint = scrollPoint
    isExecute = false // 終了
  })
}

//  ##      #####
//  ##      ##  ##
//  ##      #####
//  ##      ##
//  ######  ##
// 初回訪問時はLPに飛ばす
/* global hUrl */
// const viewLP = getCookie('viewLP') // Cookie取得
// if (!viewLP && location.href !== hUrl + 'service/') {
//   location.href = hUrl + 'service/'
// }

//  ###    ###            ##       #####    ####  ##  ##
//  ## #  # ##            ##      ##   ##  ##     ## ##
//  ##  ##  ##  ########  ##      ##   ##  ##     ####
//  ##      ##            ##      ##   ##  ##     ## ##
//  ##      ##            ######   #####    ####  ##  ##
// モーダルを消して閉じれなくする（Ajaxで呼び出した要素内のボタンで閉じる）

window.addEventListener('click', function (e) {
  // 指定のセレクタに該当する
  if (!e.target.closest('.js-modalLock')) {
    return
  }
  const modalClose = document.querySelectorAll('.js-modal-close, .modal__close')
  for (const iterator of modalClose) {
    iterator.style.display = 'none'
    iterator.classList.add('modal-lock')
  }
})

// モーダルが閉じられる時、ロックを解除する
window.addEventListener('click', function (e) {
  // 指定のセレクタに該当する
  if (!e.target.closest('.js-modal-close')) {
    return
  }
  const modalClose = document.getElementsByClassName('modal-lock')
  for (const iterator of modalClose) {
    iterator.style.display = ''
  }
})

//  #####             ######   #####    ####     ####    ##      #####
//  ##  ##              ##    ##   ##  ##       ##       ##      ##
//  #####   ########    ##    ##   ##  ##  ###  ##  ###  ##      #####
//  ##                  ##    ##   ##  ##   ##  ##   ##  ##      ##
//  ##                  ##     #####    ####     ####    ######  #####
/*
パスワード欄の可視化を切り替える
<input type="password" name="password" class="js-passToggle--login" placeholder="">
<button type="button" class="js-passToggle activeToggle flex vcenter hcenter" data-pass="login">
    <i class="is-false activeToggle__off icon-show"></i>
    <i class="is-false activeToggle__on icon-hide"></i>
</button>
*/
if (document.getElementsByClassName('js-passToggle')[0]) {
  window.addEventListener('click', function (e) {
    // 指定のクラスを持つ
    if (!e.target.classList.contains('js-passToggle')) {
      return
    }
    const target = e.target.dataset.pass
    const targetList = document.getElementsByClassName('js-passToggle--' + target)
    if (!e.target.classList.contains('active')) {
      for (const iterator of targetList) {
        iterator.type = 'name'
      }
    } else {
      for (const iterator of targetList) {
        iterator.type = 'password'
      }
    }

    e.target.classList.toggle('active')
  })
}

//  ####    #####   ####  ######  #####     #####   ##    ##
//  ##  ##  ##     ##       ##    ##  ##   ##   ##   ##  ##
//  ##  ##  #####   ###     ##    #####    ##   ##    ####
//  ##  ##  ##        ##    ##    ##  ##   ##   ##     ##
//  ####    #####  ####     ##    ##   ##   #####      ##
/*
data属性に対応するクラスのDOMを削除する
<button type="button" class="js-destroy" data-destroy="hoge">
    削除
</button>
<div class="js-destroy--hoge">これが消える</div>
*/

window.addEventListener('click', function (e) {
  // 指定のクラスを持つ
  if (!e.target.classList.contains('js-destroy')) {
    return
  }
  const target = e.target.dataset.destroy
  const destroyList = document.getElementsByClassName('js-destroy--' + target)

  for (const iterator of destroyList) {
    iterator.parentNode.removeChild(iterator)
  }
})
